/// <reference types="vite-plus/client" />
import { createClient } from "@supabase/supabase-js";
import { requiredEnvVars } from "./env";

export const supabaseClient = createClient(requiredEnvVars.VITE_SUPABASE_URL, requiredEnvVars.VITE_SUPABASE_ANON_KEY);
